import styled from '@emotion/styled'
import React from 'react'

interface Props {}

const BackToTop: React.FC<Props> = () => {
  return <a href="#root">&#8593; Top</a>
}

export default BackToTop
